<template>
  <div class="header">
    <div class="logo">
      <img src="images/logo.svg" alt="logo" @click="$router.push({name: 'dashboard'})">
    </div>
    <i class="pi pi-bars burger-icon" @click="menuMob = true"></i>
    <Sidebar v-model:visible="menuMob" :showCloseIcon="false">
      <img src="images/logo.svg" alt="logo" class="logo-mob">
      <menu-mob version="mobile" @close="menuMob = false"/>
    </Sidebar>
    <div class="wrapper">
      <div class="badges-container">
        <div class="badge" :class="{'badge-gray': holdSum === 0, 'badge-yellow': holdSum > 0}">
          <span class="badge-label">Hold:</span>
          <span class="badge-value">{{profile.currency ==='EUR'? '€': '$'}}{{ formatAmount(holdSum) }}</span>
        </div>
        <div class="badge" :class="{'badge-gray': dueToPayoutSum === 0, 'badge-green': dueToPayoutSum > 0}">
          <span class="badge-label">Due to Payout:</span>
          <span class="badge-value">{{profile.currency ==='EUR'? '€': '$'}}{{ formatAmount(dueToPayoutSum) }}</span>
        </div>
      </div>
      <Locales/>
    </div>
  </div>
</template>

<script>
import MenuMob from "@/components/menu";
import {getOrdersSummaryApi} from "@/api/order";
import Locales from "@/components/locales.vue";
import {mainStore} from "@/store/main";

export default {
  name: "header",
  components: {MenuMob, Locales},
  data() {
    return {
      menuMob: false,
      holdSum: 0,
      dueToPayoutSum: 0
    }
  },
  mounted() {
    this.getOrdersSummary()
  },
  computed: {
    profile() {
      return mainStore().infoProfile
    }
  },
  methods: {
    getOrdersSummary() {
      getOrdersSummaryApi().then((resp) => {
        const data = resp.data;
        this.holdSum = data.holdSum || 0;
        this.dueToPayoutSum = data.dueToPayoutSum || 0;
      }, (error) => {
      })
    },
    formatAmount(amount) {
      return Number(amount).toFixed(2);
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  position: relative;
  z-index: 99;
  background-color: #ffffff;
  height: 80px;
  display: flex;
  align-items: center;
}

.wrapper {
  width: calc(100% - 220px);
  display: flex;
  justify-content: end;
  align-items: center;
  height: 100%;
  box-shadow: 10px 4px 11px 1px #88A2FF1F;
}

.logo {
  width: 220px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }
}

.badges-container {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-right: 25px;
}

.badge {
  border-radius: 8px;
  height: 40px;
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border: 0.5px solid;
  min-width: fit-content;
}

.badge-yellow {
  background-color: #FEFCE8;
  border-color: #F3E6BB;
  color: #584F14;
}

.badge-green {
  background-color: #F0FDF4;
  border-color: #C4EBD2;
  color: #1B5E20;
}

.badge-gray {
  background-color: #E8EBF1;
  border-color: #D7DCE9;
  color: #2F3856;
}

.badge-label {
  font-size: 14px;
  font-weight: 500;
}

.badge-value {
  font-size: 14px;
  font-weight: 600;
}

.burger-icon {
  display: none;
}

@media screen and (max-width: 1365px) {
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0; /* Добавьте для страховки */
    padding: 0 20px;
    box-shadow: 10px 4px 11px 1px #88A2FF1F;
    height: 64px;
    z-index: 100;
  }
  .logo {
    display: none;
  }
  .wrapper {
    width: 100%;
    box-shadow: none;
  }
  .burger-icon {
    font-size: 28px;
    display: block;
  }
  .badges-container {
    margin-right: 15px;
    gap: 8px;
  }

  .badge {
    padding: 0 8px;
    height: 36px;
    font-size: 12px;
  }

  .badge-label {
    font-size: 12px;
  }

  .badge-value {
    font-size: 12px;
  }
  .logo-mob {
    margin: 15px 0 15px 1rem;
  }
}
</style>
